import { memo } from 'react'
import { useTranslations } from '@/core/translation'
import { isEventDateTimeTbd } from '@/utils'
import { Box } from '@/components/Layout'
import { Dot, Text } from '@/components/Data'
import { headerEventInfoStyles as styles } from './/HeaderEventInfo.style'
import { SxProps } from '@mui/material'
import { HeaderProps } from '../Header.types'

interface HeaderEventInfoProps extends Pick<HeaderProps, 'packageInfo' | 'hidePackageInfo'> {}

function HeaderEventInfo({ packageInfo, hidePackageInfo }: HeaderEventInfoProps) {
  const t = useTranslations('header')
  const { event } = packageInfo ?? {}

  if (!event || hidePackageInfo) return null

  const { isDateTbd, isTimeTbd } = isEventDateTimeTbd(event.timings.time, event.name)

  return (
    <Box sx={styles.eventInfoWrapper}>
      <Text sx={styles.eventName} className="ellipsis" component={'h2'}>
        {event.name}
      </Text>
      <Box sx={styles.eventDescWrapper}>
        <Text sx={[styles.eventDesc, styles.venueDesc] as SxProps} component={'h2'}>
          {event.venue.name}, {event.venue.address.city}, {event.venue.address.region}
        </Text>
        <Dot sx={styles.dot} light />
        <Text sx={styles.eventDesc} component={'h2'}>
          {isDateTbd
            ? t('event.tbd')
            : `${event.timings.day} ${event.timings.month} ${event.timings.date} ${t('event.timingAt')} ${isTimeTbd ? t('event.tbd') : event.timings.time}`}
        </Text>
      </Box>
    </Box>
  )
}

export default memo(HeaderEventInfo)
